module.exports = __webpack_public_path__ + "static/media/IconoGranPregunta.d2ac343b.svg";